import React from "react";
import styles from "./PasswordValidator.module.css";

type Props = {
    password: string;
};

const PasswordValidator: React.FC<Props> = ({password}) => {
    const validations = [
        {
            isValid: password.length >= 8,
            message: "At least 8 characters.",
        },
        {
            isValid: /[a-z]/.test(password),
            message: "At least one lowercase letter.",
        },
        {
            isValid: /[A-Z]/.test(password),
            message: "At least one uppercase letter.",
        },
        {
            isValid: /\d/.test(password),
            message: "At least one number.",
        },
        {
            isValid: /[!@#$%^&*(),.?":{}|<>]/.test(password),
            message: "At least one special character (e.g. !@#$%^&*).",
        },
    ];

    return (
        <ul className={styles.validationList}>
            {validations.map((validation, index) => (
                <li
                    key={index}
                    className={
                        validation.isValid
                            ? styles.valid
                            : styles.invalid
                    }
                >
                    {validation.message}
                </li>
            ))}
        </ul>
    );
};

export default PasswordValidator;